import React, { Suspense, useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import api from '@utils/api';
import { freeExpressShippingCustomerGroup } from '@utils/constants';
const LoginModal = React.lazy(() => import('@components/login/LoginModal'));
const ShippingDisclaimer = (props) => {
    const { t } = useTranslation();
    const [promotionInfo, setPromotionInfo] = useState();
    const [campaignActive, setCampaingActive] = useState(false);
    const [hasFreeExpressShipping, setHasFreeExpressShipping] = useState(false);
    const [loginOpen, setLoginOpen] = useState(false);
    useEffect(() => {
        api.getPromotionInfo().then((data) => {
            var _a, _b;
            setPromotionInfo(data);
            if ((_a = data.activeCampaigns) === null || _a === void 0 ? void 0 : _a.includes(window.promoFreeExpressShippingNewMembers)) {
                setCampaingActive(true);
            }
            if ((_b = data.customerGroups) === null || _b === void 0 ? void 0 : _b.includes(freeExpressShippingCustomerGroup)) {
                setHasFreeExpressShipping(true);
            }
        });
    }, []);
    if (!promotionInfo || !campaignActive || (window.loggedin && !hasFreeExpressShipping)) {
        return React.createElement(React.Fragment, null);
    }
    return (React.createElement("div", { className: "product-selection__shipping-disclaimer" },
        props.incontext == 'productSelection' && (React.createElement("p", { className: "shipping-disclaimer__title" },
            React.createElement("i", { className: "icon--members", "aria-label": "members only" }),
            t('expressshippingfree.title'))),
        React.createElement("div", { className: "shipping-disclaimer_description" },
            React.createElement("span", { className: "mr-8" },
                React.createElement(React.Fragment, null,
                    props.incontext == 'productSelection' && t('expressshippingfree.description'),
                    props.incontext == 'bag' && React.createElement("strong", null, (promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo.guest) ? t('bag.freeexpressdeliveryguest') : t('bag.freeexpressdelivery')))),
            React.createElement(Suspense, { fallback: React.createElement(React.Fragment, null) }, (promotionInfo === null || promotionInfo === void 0 ? void 0 : promotionInfo.guest) && (React.createElement(LoginModal, { incontext: "membersonly", reloadPage: true, modalStatus: loginOpen, updateStatus: (status) => setLoginOpen(status), buttonText: t('expressshippingfree.loginbutton'), customClass: "button--link-button bold" }))))));
};
export default ShippingDisclaimer;
